import React from 'react'

import { COLORS } from 'theme'
import { CardValue, SingleCard1 } from './style'

const TimeCard = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 15px',
  width = 'auto',

  height,
  state,
  current,

  text1 = '',
  text2 = '',

  index,
  activeTime,
  setActiveTime,
  Item,
  setSelectedTime,
  setCurrentTimeDetails,
}) => {
  const clickedFn = value => {
    setActiveTime(value)
    setSelectedTime(Item)
    setCurrentTimeDetails(Item)
  }
  return (
    <SingleCard1
      onClick={() => clickedFn(index)}
      background={current && state == current ? COLORS.BLUE_T_80 : background}
      padding={padding}
      width={width}
      column
      flexStart
      height={height}
      styleProps={activeTime === index}
    >
      <CardValue>
        {' '}
        {text1} - {text2}
      </CardValue>
    </SingleCard1>
  )
}

export default TimeCard
